/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate is the countdown?`)
};

const es_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué precisión tiene la cuenta atrás?`)
};

const de_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genau ist der Countdown?`)
};

const nl_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe nauwkeurig is de aftelling?`)
};

const fr_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la précision du compte à rebours ?`)
};

const it_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è preciso il conto alla rovescia?`)
};

const pt_br2_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a precisão da contagem regressiva?`)
};

const pt_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão precisa é a contagem decrescente?`)
};

const ja_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カウントダウンの精度はどのくらいですか?`)
};

const zh_cd_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒计时有多准确？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_q1", locale)
	if (locale === "en") return en_cd_faq_q1(inputs)
	if (locale === "es") return es_cd_faq_q1(inputs)
	if (locale === "de") return de_cd_faq_q1(inputs)
	if (locale === "nl") return nl_cd_faq_q1(inputs)
	if (locale === "fr") return fr_cd_faq_q1(inputs)
	if (locale === "it") return it_cd_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_q1(inputs)
	if (locale === "pt") return pt_cd_faq_q1(inputs)
	if (locale === "ja") return ja_cd_faq_q1(inputs)
	return zh_cd_faq_q1(inputs)
};